(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('pcsApp')
        .constant('VERSION', "1.5.55")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
